/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Non_ForcedInputs */



/**
* | output |
* | --- |
* | "Non-Forced" |
*
* @param {Editor_Filter_Non_ForcedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_non_forced = /** @type {((inputs?: Editor_Filter_Non_ForcedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Non_ForcedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non forcé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht erzwungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non forzato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Непринудительные")
	if (locale === "es") return /** @type {LocalizedString} */ ("No forzado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("非强制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("非強制")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गैर-बाध्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não Forçado")
	return /** @type {LocalizedString} */ ("Non-Forced")
});